export const convertStrToSlug = (str) => str.toLowerCase().replace(/\s+/g, "-");

export const hexToRgba = (hex, alpha) => {
  const cleanHex = hex.replace("#", "");
  const bigint = parseInt(cleanHex, 16);

  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
